
import { defineComponent, provide } from "vue";
import { DefaultApolloClient } from "@vue/apollo-composable";

import SideBar from "@/components/SideBar.vue";
import TimerAssistantContainer from "@/components/TimerAssistantContainer.vue";

import { apolloClient } from "./apollo.provider";

export default defineComponent({
  setup() {
    provide(DefaultApolloClient, apolloClient);
  },
  methods: {
    hasSideBar() {
      if (
        this.$route.name?.toString() === "Login" ||
        this.$route.name?.toString() === "Verify" ||
        this.$route.name?.toString() === "SignedOrderAction" ||
        this.$route.name?.toString() === "SignedRecurringOrderAction"
      )
        return false;
      return true;
    },
    getClass() {
      if (this.hasSideBar()) return "router-view";
      return "login-router-view";
    },
    showTimerAssistant() {
      if (
        this.$route.name?.toString() === "SignedOrderAction" ||
        this.$route.name?.toString() === "SignedRecurringOrderAction"
      )
        return false;
      return true;
    },
  },
  components: {
    SideBar,
    TimerAssistantContainer,
  },
});
